/**
 * Persiste singletons no globalThis para sobreviver ao HMR do Vite em dev.
 * Sem isso, recarregar módulos zera auth/workspace e causa tela preta no localhost.
 */
export function getGlobalSingleton<T>(key: string, factory: () => T): T {
  const g = globalThis as typeof globalThis & Record<string, T | undefined>;
  if (!g[key]) {
    g[key] = factory();
  }
  return g[key]!;
}
